import styled from 'styled-components'

export const CrossResultList = styled.div`
  padding-top: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;

  * > button {
    :hover {
      text-decoration: none;
    }
  }

  // overwrite css from base styles
  @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
    min-width: auto !important;
  }

  Button {
    color: ${ (props) => props.theme.colors['aok-gruen'] };
    text-decoration: none;
    font-size: 18px;
  }

  /** component closed styles **/
  .closed-result-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 30px;
    margin-top: 0;
    cursor: pointer;

    // overwrite css from base styles
    &::after {
      display: none;
    }

    .title-container {
      width: auto;
      display: flex;
      flex-direction: row;
      align-content: center;
      line-height: 1.23;
      font-size: 22px;
      justify-content: flex-start;

      .title-closed {
        color: ${ (props) => props.theme.colors['aok-gruen'] };
        margin-right: 10px;
      }

      .results-closed {
        display: flex;
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        flex-direction: column;
      }
    }

    > Button {
      width: auto;
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      flex-direction: column;
      padding: 20px 15px;
      min-width: auto !important;

      .header-btn {
        margin-top: 8px;
      }
    }
  }

  /** component open styles **/
  .open-result-container {
    border-top: 1px solid ${ (props) => props.theme.colors.partingLine };
    padding-top: 10px;

    .results-information {
      padding-left: 0;

      .title-open {
        display: flex;
        flex-direction: row;
        font-size: 22px;
        color: ${ (props) => props.theme.colors['standard-schwarz'] };
      }

      .filters-by {
        margin: 14px 0 20px 0;
        font-size: 18px;
        color: ${ (props) => props.theme.colors['standard-schwarz'] };
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        > Button {
          margin-top: 10px;
        }
      }
    }

    .results-container {
      padding-right: 0;

      @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        padding: 0;
      }

      .results-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 8px 0 20px;

        .results-header-details {
          font-size: 16px;
          color: ${ (props) => props.theme.colors['panel-inner-border'] };
        }
      }

      .results {
        position: relative;
        padding-bottom: 60px;

        @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
          padding-top: 10px;
        }

        &.with-bottom-course {
          &::after {
            position: absolute;
            pointer-events: none;
            bottom: 0;
            content: '';
            display: block;
            width: 100%;
            height: 230px;
            background-image: linear-gradient(
              to bottom,
              rgba(237, 239, 239, 0),
              rgba(237, 239, 239, 0.5) 17%,
              #edefef 70%
            );
          }
        }

        > div {
          margin-bottom: 10px;
        }

        > a {
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: ${ (props) => props.theme.zIndices.dropdown };

          > button {
            color: #fff;
          }
        }
      }
    }
  }
`
